import * as React from 'react'
import { SVGProps } from 'react'

const SvgReroll = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m14.318 8-.415.8.55.284.463-.412L14.318 8ZM1.113 6.952a.9.9 0 0 0 1.774.305l-1.774-.305Zm11.688-.751a.9.9 0 1 0-.828 1.598l.828-1.598Zm3.798.97A.9.9 0 1 0 15.4 5.829L16.6 7.172ZM15.217 8c0-2.139-.786-3.834-2.033-5.013-1.232-1.165-2.867-1.78-4.512-1.874-3.28-.188-6.85 1.71-7.559 5.839l1.774.305c.522-3.036 3.11-4.495 5.682-4.347 1.28.073 2.495.55 3.379 1.386.87.822 1.47 2.037 1.47 3.704h1.8Zm-.486-.8-1.93-1-.828 1.6 1.93 1 .829-1.6Zm.185 1.472 1.683-1.5L15.4 5.828l-1.682 1.5 1.197 1.344Z"
      fill="#00A965"
    />
    <path
      d="M2.682 10c0 7.612 11.086 8.06 12.318.896M2.682 10l1.93 1m-1.93-1L1 11.5"
      stroke="#00A965"
      strokeWidth={1.8}
      strokeLinecap="round"
    />
  </svg>
)

export default SvgReroll
